import { render, staticRenderFns } from "./ModalProductsDelivered.vue?vue&type=template&id=232eecdc&"
import script from "./ModalProductsDelivered.vue?vue&type=script&lang=js&"
export * from "./ModalProductsDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports